import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function FAQ() {
  const faqs = [['¿Es un producto físico?', 'No. Es una biblioteca documental digital para acceder y leer desde tus dispositivos.'], ['¿Cuándo recibo el acceso?', 'Inmediatamente después de confirmar tu compra.'], ['¿Puedo verlo desde mi celular?', 'Sí. El contenido está preparado para celular, tablet y computadora.'], ['¿Está en español?', 'Sí, toda la colección está escrita íntegramente en español.'], ['¿Necesito internet para leerlo?', 'Solo para descargar el material. Después puedes consultarlo cuando quieras.'], ['¿Cómo recibo los bonos?', 'Los tres bonos se habilitan junto con el acceso a los seis tomos.']];
  const [open, setOpen] = useState(0);
  return <section className="bg-dark-card/45 px-5 py-24 md:py-32" data-id="element-80">
      <div className="mx-auto max-w-3xl" data-id="element-81">
        <div className="mb-12 text-center" data-id="element-82">
          <p className="text-xs font-bold uppercase tracking-[.22em] text-gold" data-id="element-83">
            Resolvemos tus dudas
          </p>
          <h2 className="mt-3 text-4xl font-semibold text-stone-light md:text-6xl" data-id="element-84">
            Preguntas frecuentes
          </h2>
        </div>
        <div className="space-y-3" data-id="element-85">
          {faqs.map(([question, answer], index) => <div key={question} className="overflow-hidden rounded-xl border border-dark-border bg-dark" data-id="element-86">
              <button onClick={() => setOpen(open === index ? -1 : index)} className="flex w-full items-center justify-between px-6 py-5 text-left text-sm font-semibold text-stone-light" data-id="element-87">
                <span data-id="element-88">{question}</span>
                <ChevronDownIcon className={`h-5 w-5 shrink-0 text-gold-light transition-transform ${open === index ? 'rotate-180' : ''}`} data-id="element-89" />
              </button>
              <AnimatePresence data-id="element-90">
                {open === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} data-id="element-91">
                    <p className="border-t border-dark-border px-6 py-5 text-sm leading-6 text-stone" data-id="element-92">
                      {answer}
                    </p>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}